export enum eventTypes {
  button_clicked = 'BUTTON_CLICKED',
  page_loaded = 'PAGE_LOADED',
  notification_clicked = 'NOTIFICATIN_CLICKED',
  axios_request = 'AXIOS_REQUEST',
}
